<template>
  <div>
    <div class="fixed-header">
      <div class="heading">
        {{ $t('consumer.list.heading') }}
        <div class="button warning xsmall notif-btn"
          @click="showNotifForm">{{ $t('consumer.list.sendNotif') }}</div>
      </div>
      <list-filter></list-filter>
    </div>

    <!--
    <div class="button cta success import">
      <i class="fa fa-upload"></i>{{ $t('consumer.referrals.export') }}
    </div>
    -->

    <div class="sticky" v-if="!isMobile">
      <table>
        <thead>
          <th class='status'><input type="checkbox" v-model="selectAll" /></th>
          <th><i class="fab fa-stripe-s"></i></th>
          <th>{{ $t('consumer.list.firstName') }}</th>
          <th>{{ $t('consumer.list.lastName') }}</th>
          <th>{{ $t('consumer.list.email') }}</th>
          <th>{{ $t('consumer.list.mobile') }}</th>
          <th>{{ $t('consumer.list.created') }}</th>
          <th>{{ $t('consumer.list.referralCode') }}</th>
          <th>{{ $t('consumer.list.details') }}</th>
          <th>{{ $t('consumer.list.status') }}</th>
        </thead>
        <tbody>
          <tr v-for="user in users">
            <td class='status'><input type="checkbox" v-model="selected" :value="user.id" number /></td>
            <td>
              <span v-if="user.customerURL === null">--</span>
              <a href="javascript:;" :href="user.customerURL" target="_blank" v-else><i class="fa fa-link"></i></a>
            </td>
            <td>{{ user.firstName }}</td>
            <td>{{ user.lastName }}</td>
            <td>{{ user.email }}</td>
            <td><a @click="call(user)">{{ user.mobile }}</a></td>
            <td>{{ user.created }}</td>
            <td>{{ user.referralCode }}</td>
            <td><a v-bind:href="'/#/consumer/' + user.id" target="_blank">View</a></td>
            <td><label :class="['status-label', user.status]">{{ user.status }}</label></td>
          </tr>
        </tbody>
      </table>
    </div>

    <table class="main-table" v-if="!isMobile">
      <thead>
        <th class='status'>
          <input type="checkbox" v-model="selectAll" />
        </th>
        <th><i class="fab fa-stripe-s"></i></th>
        <th>{{ $t('consumer.list.firstName') }}</th>
        <th>{{ $t('consumer.list.lastName') }}</th>
        <th>{{ $t('consumer.list.email') }}</th>
        <th>{{ $t('consumer.list.mobile') }}</th>
        <th>{{ $t('consumer.list.created') }}</th>
        <th>{{ $t('consumer.list.referralCode') }}</th>
        <th>{{ $t('consumer.list.details') }}</th>
        <th>{{ $t('consumer.list.status') }}</th>
      </thead>
      <tbody>
        <tr v-for="user in users">
          <td class='status'>
            <input type="checkbox" v-model="selected" :value="user.id" number />
          </td>
          <td>
            <span v-if="user.customerURL === null">--</span>
            <a href="javascript:;" :href="user.customerURL" target="_blank"v-else><i class="fa fa-link"></i></a>
          </td>
          <td>{{ user.firstName }}</td>
          <td>{{ user.lastName }}</td>
          <td>{{ user.email }}</td>
          <td><a @click="call(user)">{{ displayPhone(user) }}</a></td>
          <td>{{ user.created }}</td>
          <td>{{ user.referralCode }}</td>
          <td><a v-bind:href="'/#/consumer/' + user.id" target="_blank">View</a></td>
          <td><label :class="['status-label', user.status]">{{ user.status }}</label></td>
        </tr>
        <tr v-show="isLoading" class="tr-loader">
          <td colspan="13" class="table-block">
            <transition name="slide-up">
              <div v-show="isLoading" class="loader">
                <i class="fas fa-spinner fa-spin"></i>
                {{ $t('consumer.list.gettingUsers') }}
              </div>
            </transition>
          </td>
        </tr>
      </tbody>
    </table>

    <div v-else class="card-div">
      <div class="cards" v-for="(user, i) in users" :key="i">
          <div class="card">
            <div class="title card-header">
              <div class="time">
                <div class="title">
                  <input type="checkbox" v-model="selected" :value="user.id" number />
                  <span class="label">Created: </span>
                  <div class="value">{{ user.created }}</div>
                </div>
              </div>
              <div class="link">
                <label :class="['status-label', user.status]">{{ user.status }}</label>
                <div>
                  <span v-if="user.customerURL === null">--</span>
                  <a href="javascript:;" :href="user.customerURL" target="_blank" v-else><i class="fa fa-link"></i></a>
                </div>
              </div>
            </div>
            <div class="title">
              <div class="value"><i class="fas fa-address-card"></i> {{ user.firstName }} {{ user.lastName }}</div>
            </div>
            <div class="title">
              <div class="value"><i class="fas fa-envelope"></i> {{ user.email }}</div>
            </div>
            <div class="title">
              <div class="value"><i class="fas fa-phone"></i> <a @click="call(user)">{{ displayPhone(user) }}</a></div>
            </div>
            <div class="title view">
              <div class="refer">
                <span class="label">Referral Code:</span>
                <div class="value">{{ user.referralCode }}</div>
              </div>
              <div class="value"><a v-bind:href="'/#/consumer/' + user.id" target="_blank">View</a></div>
            </div>
          </div>
      </div>
    </div>

    <div class="fix-footer">
      <div class="row">
        <div class="small-3 columns per-page">
          <span>Displaying</span>
          <select v-model="perPage" :disabled="loading">
            <option value="5">5</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <!-- <option value="500">500</option> -->
          </select>
          <span>per page</span>
        </div>

        <div class="small-6 columns page-data">
          <span v-show="users.length > 0">
            Displaying
            <b>{{ pageData.start }}</b> - <b>{{ pageData.end }}</b> of
            <b>{{ pageData.max }}</b>
          </span>
        </div>

        <div class="small-3 columns pagination">
          <span>Page</span>
          <span :class="{'prevNext':true, 'disabled':currentPage === 1 || loading}" @click="prev">
            <i class="fas fa-chevron-left"></i>
          </span>
          <select v-model="currentPage" :disabled="loading">
            <option v-for="i in totalPage" :value="i">{{i}}</option>
          </select>
          <span :class="{'prevNext':true, 'disabled':isLastPage || loading}" @click="next">
            <i class="fas fa-chevron-right"></i>
          </span>
        </div>
      </div>
    </div>

    <div v-bind:class="{ 'op--modal-container':true, hide: !notification.showForm }" @click="closeNotifForm">
      <div class="op--modal">
        <div class="op--modal-content">
          <div @click.stop class="notification-form">
            <div class="modal-heading">{{ $t('consumer.list.pushNotif') }}</div>
            <div class="nf-content" @click="closeEmoji">
              <div v-show="!notification.errorMsg && !notification.success">
                <div :class="{'data-field':true, 'has-error':!!notification.targetMessage}">
                  <div class="label">{{ $t('consumer.list.target') }}:</div>
                  <select v-model="notification.target">
                    <option value="all">{{ $t('consumer.list.allUser') }}</option>
                    <option value="selected">{{ $t('consumer.list.selectedUser') }}</option>
                  </select>
                  <span class="error-msg">{{ notification.targetMessage }}</span>
                </div>

                <div v-show="notification.target === 'all'"
                  :class="{'data-field':true, 'has-error':!!notification.brandErrorMsg}">
                  <div class="label">{{ $t('consumer.list.brands') }}:</div>
                  <select v-model="notification.brand">
                    <option v-for="brand in brands" :value="brand.id">{{ brand.name }}</option>
                  </select>
                  <span class="error-msg">{{ notification.brandErrorMsg }}</span>
                </div>

                <label v-if="false">
                  <input type="checkbox" v-model='notification.isPushNotif' />
                  {{ $t('consumer.list.pushNotif') }}
                </label>
                <label v-if="false">
                  <input type="checkbox" v-model='notification.isSendEmail' />
                  {{ $t('consumer.list.email') }}
                </label>

                <div :class="{'data-field':true, 'has-error':!!notification.titleError}">
                  <div class="label">{{ $t('consumer.list.title') }}:</div>
                  <input type="text" v-model="notification.title" class="input" />
                  <span class="error-msg">{{ notification.titleError }}</span>
                </div>

                <div class="textarea-box">
                  <textarea v-model='notification.message' rows="5"
                    :class="{'exceed':notification.charExceed}"
                    v-on:keydown="charCountUpdate" v-on:keyup="charCountUpdate"
                    :placeholder="$t('consumer.list.message')" ref="notifMsg"></textarea>
                  <i class="far fa-smile fa-lg emoji-trigger" @click.stop
                    @click="notification.showEmoji = !notification.showEmoji"></i>
                  <span class="error-msg">{{ notification.messageError }}</span>
                  <!-- <span :class="{'char-count':true, 'exceed':notification.charExceed}">
                    {{ $t('consumer.list.charLeft', {count: notification.charCount}) }}
                  </span> -->
                </div>

                <div :class="{'data-field':true, 'has-error':!!notification.fileError}" v-if="false">
                  <div class="label">{{ $t('consumer.list.img') }}:</div>
                  <div class="file-box">
                    <input type="file" name="image" accept="image/*" v-if="notification.fileReady"
                      @change="setImage" class="input-file" ref="fileInput" />
                    <i class="fas fa-times fa-lg" @click="cleanFileInput"
                      v-if="!!notification.file"></i>
                  </div>
                  <span class="error-msg">{{ notification.fileError }}</span>
                </div>

                <div @click="checkFileUpload"
                  :class="{'button cta warning block':true, 'disabled':disableNotifButton}">
                  {{ $t('consumer.list.send') }}
                </div>
                <a class="cancel-notif" @click="closeNotifForm">{{ $t('consumer.list.cancel') }}</a>
              </div>

              <div v-show="!!notification.errorMsg" class="error">
                <i class="far fa-frown fa-5x"></i>
                <p>{{ $t('consumer.list.errorMsg') }}</p>
                <code>{{ notification.errorMsg }}</code>
                <div class="button cta block small error"
                  @click="closeNotifForm">{{ $t('consumer.list.close') }}</div>
              </div>

              <div v-show="notification.success" class="success-box">
                <i class="far fa-check-circle fa-5x"></i>
                <p>{{ $t('consumer.list.sendNotifSuccess') }}</p>
                <div class="button cta block small success"
                  @click="closeNotifForm">{{ $t('consumer.list.close') }}</div>
              </div>

              <transition name="slide-left">
                <div @click.stop v-show="notification.showEmoji" class="emoji-box">
                <picker :style="emojiStyle" :exclude="['recent']" @select="addEmoji" />
                </div>
              </transition>

              <transition name="pop">
                <div class="loader" v-show="notification.loading">
                  <div>
                    <i class="fas fa-spinner fa-spin"></i>
                    <span>{{ $t('consumer.list.sendingNotif') }}</span>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-bind:class="{ 'op--modal-container':true, hide: !statusUpdate.showConfirmation }"
      @click="closeStatusUpdate">
      <div class="op--modal">
        <div class="op--modal-content">
          <div @click.stop class="status-confirmation">
            <div v-show="!statusUpdate.errorMsg && !statusUpdate.success">
              <p>{{ $t('consumer.list.confirmLabel', {action: reactivateSelected ? 're-activate' : 'disable'}) }}</p>

              <div class="button cta block xsmall success"
                @click="updateStatus">{{ $t('consumer.list.yesUpdate') }}</div>
              <a class="cancel" @click="closeStatusUpdate">{{ $t('consumer.list.cancel') }}</a>
            </div>

            <div v-show="!!statusUpdate.errorMsg" class="error">
              <i class="far fa-frown fa-5x"></i>
              <p>{{ $t('consumer.list.errorMsg') }}</p>
              <code>{{ statusUpdate.errorMsg }}</code>
              <div class="button cta block small error"
                @click="closeStatusUpdate">{{ $t('consumer.list.close') }}</div>
            </div>

            <div v-show="statusUpdate.success" class="success-box">
              <i class="far fa-check-circle fa-5x"></i>
              <p>{{ $t('consumer.list.statusUpdateSuccess') }}</p>
              <div class="button cta block small success"
                @click="closeStatusUpdate">{{ $t('consumer.list.close') }}</div>
            </div>

            <transition name="pop">
              <div class="loader" v-show="statusUpdate.loading">
                <div>
                  <i class="fas fa-spinner fa-spin"></i>
                  <span>{{ $t('consumer.list.statusUpdateLoading') }}</span>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Picker } from 'emoji-mart-vue'
import ApiConsumerList from '@/modules/api/consumer/list'
import ApiConsumerNotif from '@/modules/api/consumer/notifications'
import ApiProvider from '@/modules/api/provider/user-info'
import listFilter from './ListFilter'

export default {
  name: 'consumerList',
  data () {
    return {
      statusUpdate: {
        selected: 'reactivate',
        showConfirmation: false,
        loading: false,
        errorMsg: '',
        success: false
      },
      notification: {
        showForm: false,
        target: 'all',
        targetMessage: '',
        isPushNotif: true,
        isSendEmail: false,
        brand: '',
        brandErrorMsg: '',
        title: '',
        titleError: '',
        message: '',
        messageError: '',
        charCount: 180,
        charExceed: false,
        showEmoji: false,
        file: '',
        fileReady: true,
        uploadedUrl: '',
        fileError: '',
        loading: false,
        errorMsg: '',
        success: false
      },
      selected: [],
      searchInput: '',
      searchKeyword: '',
      disableNotifButton: false,
      isMobile: false
    }
  },
  components: { listFilter, Picker },
  computed: {
    brands () { return this.$store.state.brands.list },
    brandsLoading () { return this.$store.state.brands.loading },
    reactivateSelected () { return this.statusUpdate.selected === 'reactivate' },
    // disableNotifButton () {
    //   let zeroTarget = this.notification.target === 'selected' && !this.selected.length
    //   this.notification.targetMessage = zeroTarget ? this.$t('consumer.list.zeroSelected') : ''

    //   return zeroTarget || this.notification.message === '' || this.notification.charExceed ||
    //     this.notification.fileError !== '' || (!this.notification.isPushNotif && !this.notification.isSendEmail)
    // },
    isLoading () { return this.$store.state.consumer.users.isLoading },
    users () { return this.$store.state.consumer.users.list },
    selectAll: {
      get: function () {
        return this.users ? this.selected.length == this.users.length : false
      },
      set: function (value) {
        var selected = []
        if (value) {
          this.users.forEach(function (user) {
            selected.push(user.id)
          })
        }
        this.selected = selected
      }
    },
    emojiStyle () { return { 'width': '100%', 'height': '100%' } },
    _triggerStatusUpdate () { return this.$store.state.consumer.triggerStatusUpdate },
    perPage: {
      get: function () { return this.$store.state.consumer.users.perPage },
      set: function (value) {
        this.$store.commit('consumer/setUserPerPage', parseInt(value))
        this.$store.commit('consumer/setUserCurrentPage', 1)
        this.getUserList()
      }
    },
    pageData () {
      let tableData = this.$store.state.consumer.users
      let start = (tableData.currentPage * tableData.perPage) - (tableData.perPage - 1)
      let end = tableData.currentPage * tableData.perPage
      return {
        start: start < 1 ? 1 : start,
        end: end > tableData.maxList ? tableData.maxList : end,
        max: tableData.maxList
      }
    },
    loading () { return this.$store.state.consumer.users.isLoading },
    currentPage: {
      get: function () { return this.$store.state.consumer.users.currentPage },
      set: function (value) {
        this.$store.commit('consumer/setUserCurrentPage', parseInt(value))
        this.getUserList()
      }
    },
    isLastPage () {
      let consumer = this.$store.state.consumer.users
      return (consumer.currentPage * consumer.perPage) >= consumer.maxList
    },
    totalPage () {
      let consumer = this.$store.state.consumer.users
      return Math.ceil(consumer.maxList / consumer.perPage)
    }
  },
  methods: {
    closeStatusUpdate () {
      if (this.statusUpdate.loading) { return }
      this.statusUpdate.showConfirmation = false
      this.statusUpdate.errorMsg = ''
      this.statusUpdate.success = false
    },
    updateStatus () {
      let self = this
      if (self.statusUpdate.loading) { return }

      self.statusUpdate.loading = true

      // setTimeout(function () {
      //   self.statusUpdate.loading = false
      //   self.statusUpdate.success = true
      // }, 2000)

      ApiProvider.updateProviderStatus(self, {
        id: self.selected[0],
        isActive: self.$store.state.consumer.selectedStatus === 'activate'
      }, function (res) {
        self.statusUpdate.loading = false
        if (!res.error) {
          self.selected.shift()
          if (self.selected.length > 0) {
            self.updateStatus()
          } else {
            self.statusUpdate.success = true
            self.getUserList()
          }
        }
      })
    },
    showNotifForm () {
      this.notification.showForm = true
      this.notification.target = this.selected.length ? 'selected' : 'all'
    },
    closeNotifForm () {
      if (this.notification.showEmoji) {
        this.closeEmoji()
        return
      }

      if (this.notification.loading) { return }
      this.notification.showForm = false
      this.notification.brandErrorMsg = ''
      this.notification.errorMsg = ''
      this.notification.success = false
    },
    charCountUpdate () {
      this.notification.charCount = 180 - (this.notification.message.length)
      // if (this.notification.message === '') { this.notification.charCount = 180 }
      // this.notification.charExceed = this.notification.charCount < 0
    },
    addEmoji (emoji) {
      this.notification.showEmoji = false

      let textarea = this.$refs.notifMsg
      let cursorPosition = textarea.selectionEnd
      let start = this.notification.message.substring(0, textarea.selectionStart)
      let end = this.notification.message.substring(textarea.selectionStart)
      let text = start + emoji.native + end
      this.notification.message = text
      textarea.focus()
      let self = this
      this.$nextTick(() => {
        textarea.selectionEnd = cursorPosition + emoji.native.length
        self.charCountUpdate()
      })
    },
    closeEmoji () {
      if (this.notification.showEmoji) {
        this.notification.showEmoji = false
      }
    },
    setImage (e) {
      this.notification.file = e.target.files[0]

      if (!this.notification.file.type.includes('image/')) {
        this.notification.fileError = this.$t('consumer.list.selectImgFile')
        return;
      }
    },
    cleanFileInput () {
      this.notification.file = ''
      this.notification.fileError = ''
      this.notification.fileReady = false
      this.$nextTick(() => {
      	this.notification.fileReady = true
      })
    },
    checkFileUpload () {
      let self = this
      if (this.notification.file) {

        let fd = new FormData()
        fd.append('pic', self.notification.file, 'consumer-notif.png')

        self.$http.post(CONFIG.mediaHost + '/api/upload', fd, {
          header: { 'Content-Type': 'multipart/form-data' }
        }).then(function (res) {
          if (res.body.success) {
            self.notification.uploadedUrl = res.body.data.url
            self.submitNotif()
          }
        })
        return
      }

      self.submitNotif()
    },
    submitNotif () {
      let self = this

      if (self.validateNotifForm()) { return }

      let selectedId = self.notification.target === 'all' ? null : self.selected
      let data = {
        title: self.notification.title,
        message: self.notification.message,
        // image: self.notification.uploadedUrl,
        id: selectedId,
      }

      self.notification.brandErrorMsg = ''
      if (self.notification.target === 'all') {
        if (!self.notification.brand) {
          self.notification.brandErrorMsg = self.$t('consumer.list.emptyBrand')
          return
        }
        data.brandId = self.notification.brand
      }

      self.notification.loading = true
      ApiConsumerNotif.send(self, data, function (res) {
        self.notification.loading = false
        self.notification.success = true
        self.notification.title = ''
        self.notification.message = ''
        self.notification.uploadedUrl = ''
        self.cleanFileInput()
      })
    },
    validateNotifForm () {

      let hasError = false
      this.disableNotifButton = false
      let conList = this.$store.state.consumer.users
      this.notification.targetMessage = ''
      if (this.notification.target === 'selected') {
        if (!this.selected.length) {
          hasError = true
        }
        this.notification.targetMessage = this.selected.length === 0 ? this.$t('consumer.list.zeroSelected') : ''
      }

      this.notification.brandErrorMsg = ''
      if (this.notification.target === 'all' && !this.notification.brand) {
        this.notification.brandErrorMsg = this.$t('consumer.list.emptyBrand')
      }

      this.notification.titleError = ''
      if (this.notification.title === '') {
        hasError = true
        this.notification.titleError = 'This field cannot be empty.'
      }

      this.notification.messageError = ''
      if (this.notification.message === '') {
        hasError = true
        this.notification.messageError = 'This field cannot be empty.'
      }
      return hasError
    },
    updateKeyword () {
      if (this.isLoading) { return }
      this.selected = []
      this.searchKeyword = this.searchInput
      this.$store.commit('consumer/resetUsers')
      // this.$store.commit('consumer/setUserIsMax', false)
      self.$store.commit('consumer/setUserMaxList', 0)
      this.$store.commit('consumer/setUserCurrentPage', 1)
      this.getUserList()
    },
    getUserList () {
      let self = this
      if (self.isLoading) { return }

      self.$store.commit('consumer/setUserIsLoading', true)
      ApiConsumerList.getList(self, function (res) {
        self.$store.commit('consumer/setUserIsLoading', false)
      })
    },
    onScroll (event) {
      let scrollAndView = event.target.scrollTop + event.target.offsetHeight
      if (event.target.scrollHeight - scrollAndView < 150) {
        this.getUserList()
      }
    },
    call (user) {
      let self = this
      self.$plugins.phone.startCall(self, {
        phone: user.mobile,
        name: user.firstName + ' ' + user.lastName
      })
    },
    prev () {
      if (this.currentPage === 1) { return }
      this.$store.commit('consumer/setUserCurrentPage', this.$store.state.consumer.users.currentPage - 1)
      this.getUserList()
    },
    next () {
      if (this.isLastPage) { return }
      this.$store.commit('consumer/setUserCurrentPage', this.$store.state.consumer.users.currentPage + 1)
      this.getUserList()
    },
    setScreenSize() {
      let self = this
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        self.isMobile = true
      } else {
        self.isMobile = false
      }
    },
    displayPhone (data) {
      if (!data.countryCode) return data.mobile
      return `+${data.countryCode} ${data.nationalNumber || data.mobile}`
    }
  },
  watch: {
    _triggerStatusUpdate: function (value) {
      if (value) {
        this.$store.commit('consumer/setTriggerStatusUpdate', false)
        this.updateStatus()
      }
    }
  },
  mounted () {
    let self = this

    self.$store.commit('consumer/resetUsers')
    // self.$store.commit('consumer/setUserIsMax', false)
    self.$store.commit('consumer/setUserMaxList', 0)
    self.$store.commit('consumer/setUserCurrentPage', 1)
    self.getUserList()

    if (self.$store.state.brands.list.length === 0) {
      self.$store.commit('brands/setLoading', true)
      self.$sdk.get('/brand', {}, res => {
        self.$store.commit('brands/setLoading', false)
        let brands = []
        res.forEach(function (data) {
          brands.push({ id: data.id, name: data.name })
        })
        self.$store.commit('brands/setList', brands)
      })
    }
    self.setScreenSize()
  }
}
</script>

<style lang="scss" scoped>
.fixed-header{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 155px;
}
.heading{
  margin-left: 50px;
  padding-left: 10px;
  height: 50px;
  background: #fff;
  border-bottom: 1px solid #ddd;
  line-height: 50px;
  color: #3F2975;
  font-size: 21px;
  font-weight: 600;
  text-transform: uppercase;
}
.notif-btn{
  float: right;
  margin: 7px 10px;
}

select{
  border: 1px solid #ddd;
  padding: 5px 10px;
  color: #333;
  height: 35px;
  position: relative;
  font-size:14px;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url('/assets/img/dropdown-arrow.png');
  background-repeat: no-repeat;
  background-position: right 50%;
  transition: all .35s ease;

  &.has-error{ border-color: #f20d0d; }
  &:disabled{ background-color: #eee; }
}

.data-field{
  position: relative;
  margin-bottom: 20px;
  .label{
    color: #888;
    font-weight: 600;
    font-size: 12px;
    line-height: 130%;
    margin-bottom: 3px;

    &.has-error{ color: #f20d0d; }
  }
  .input{
    margin: 5px 0 0;
    color: #333;
    line-height: inherit;
    transition: all .35s ease;

    &.has-error{ border-color: #f20d0d; }
    &:disabled{ background: #eee; }
  }
  .error-msg{
    font-size: 11px;
    line-height: 1.6;
    color: #f20d0d;
    font-style: italic;
    display: block;
  }
}

.right-panel{
  position: fixed;
  background: #ededed;
  z-index: 2;
  width: 80%;
  height: 100%;
  top:0;
  right: 0;
  padding: 20px;
  overflow: auto;
}

.search{
  box-sizing: border-box;
  display: flex;
  width: 400px;

  input{
    display: inline-block;
    vertical-align: middle;
    margin-top: 0;
    border-radius: 5px 0 0 5px;
  }
  button{
    display: inline-block;
    vertical-align: middle;
    line-height: 1;
    border-radius: 0 5px 5px 0;
  }
}
.inline-block{ display: inline-block; }
.import{
  vertical-align: top;
  margin-left: 5px;
  .fa{ margin-right: 5px; }
}

.sticky{
  position: fixed;
  top: 153px;
  left: 0;
  width: 100%;
  overflow: hidden;
  height: 30px;
  z-index: 3;

  tbody{ visibility: hidden; }
}

.main-table{ margin: 153px 0 60px; }
table{
  border-collapse: collapse;
  width: 100%;

  thead{
    color: #8DA0A9;
    font-size: 12px;
    border: 1px solid rgba(0,0,0,0.3);
    background-color: #f5f5f5;

    th{ padding: 5px 10px; }
  }

  tbody{
    tr{
      background-color: #fff;
      border: 1px solid rgba(0,0,0,0.3);

      &.tr-loader{
        border-left: none;
        border-right: none;
      }
      td{
        padding: 10px;
        text-align: center;
        font-size: 12px;
        margin-bottom: 5px;

        &.table-block{
          padding: 30px;
          font-size: 24px;
          color: #777;
          font-weight: 600;
          font-style: italic;

          .fa{ color: #ccc; }
        }
      }
    }
  }

  .status, a{ cursor: pointer; }
}

input[type="checkbox"]{
  padding: 0;
  margin: 0;
  width: 15px;
  height: 15px;
}

.status-label{
  background: #ccc;
  color: #fff;
  font-size: 11px;
  padding: 3px 5px;
  line-height: 1;
  border-radius: 4px;
  text-transform: uppercase;

  &.unverified{ background: #ff8100; }
  &.active{ background: #45c125; }
  &.disabled{ background: #f93636; }
}

.fa-spinner{
  font-size: 36px;
  color: #1f9be6;
  margin-right: 5px;
  vertical-align: middle;
}

.fix-footer{
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background: #eaeaea;
  border-top: 1px solid #aaa;
  font-size: 13px;
  color: #555;

  .row{ max-width: 100%; }
  select{ max-width: 100px; }
  .per-page{
    display: flex;
    line-height: 30px;
    padding: 15px 0;

    span{
      display: inline-block;
      margin: 0 10px;
    }
  }
  .page-data{
    text-align: center;
    line-height: 30px;
    padding: 15px 0;
  }
  .pagination{
    text-align: right;
    padding: 15px 10px;

    span{
      display: inline-block;
      margin-right: 5px;
    }
    select{
      height: 30px;
      vertical-align: middle;
    }
    .prevNext{
      margin: 0 2px;
      padding: 0 8px;
      border: 1px solid #bbb;
      background: #fff;
      cursor: pointer;
      vertical-align: middle;
      height: 30px;

      i{ line-height:28px; }
      &.disabled{
        opacity: .4;
        cursor: default;
      }
    }
  }
}

.op--modal-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.35);
  opacity: 1;
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;

  &.hide {
    top: -100%;
    opacity: 0;
  }
}
.op--modal {
  display: table;
  width: 100%;
  height: 100%;
}
.op--modal-content {
  display: table-cell;
  vertical-align: middle;
}

.status-confirmation{
  background-color: #fff;
  max-width: 440px;
  margin: 10px auto;
  padding: 20px;
  border-radius: 3px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  overflow: hidden;
  position: relative;

  p{
    padding: 0;
    margin: 0 0 20px;
    text-align: center;
    color: #555;
    font-weight: 600;
    font-size: 15px;
  }
  .cancel{
    margin-top: 10px;
    text-align: center;
    display: block;
    color: #999;
    font-size: 14px;
    cursor: pointer;
    &:hover{ color: #555; }
  }

  .error{
    text-align: center;
    i{ color:#fd4a38; }
    p{ margin: 5px 0 20px; }
    code{
      border:2px solid #fd4a38;
      padding: 10px;
      width: 100%;
      display: block;
      font-size: 14px;
      background: #ffeeec;
      border-radius: 3px;
      margin-bottom: 30px;
    }
  }

  .success-box{
    text-align: center;
    i{ color: #26d97a; }
  }

  .loader{
    position: absolute;
    top:0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);

    div{
      position: absolute;
      top:50%;
      left: 0;
      height: 50px;
      width: 100%;
      transform: translateY(-50%);
      text-align: center;

      i{ color: #45e7f9; }
      span{
        color: #fff;
        font-size: 21px;
        font-weight: 600;
        margin-left: 5px;
        text-shadow: 1px 1px 1px rgba(0,0,0, .4);
      }
    }
  }
}

.notification-form{
  background-color: #fff;
  max-width: 400px;
  margin: 10px auto;
  border-radius: 3px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);

  .modal-heading{
    background: #333;
    color: #fff;
    padding: 10px;
    font-size: 18px;
    text-align: center;
  }

  .nf-content{
    padding: 20px;
    position: relative;

    .label{
      font-size: 13px;
      color: #555;
    }
    label{
      display: block;
      font-size: 14px;
      color: #555;
      margin-bottom: 2px;
      cursor: pointer;

      input{
        display: inline-block;
        vertical-align: middle;
        margin-right: 5px;
      }
    }
    .textarea-box{
      position: relative;
      margin-bottom: 20px;
      padding-bottom: 20px;

      .emoji-trigger{
        position: absolute;
        top: 133px;
        right: 0;
        color: #aaa;
        cursor: pointer;
      }
      .error-msg{
        font-size: 11px;
        line-height: 1.6;
        color: #f20d0d;
        font-style: italic;
        display: block;
      }
    }
    textarea{
      margin: 0;
      padding: 10px;
      width: 100%;
      resize: none;
      background: #fdfdfd;
      font-size: 14px;
      outline: none;
      color: #333;
      border-color: #ddd;
      box-shadow: 1px 1px 3px rgba(0,0,0, .05) inset;
      transition: all .3s ease;

      &.exceed{
        border-color: #d61613;
        background: #fff0f0;
      }
    }
    .char-count{
      font-size: 12px;
      color: #777;
      display: block;
      text-align: right;
      line-height: 1;
      margin-top: 5px;

      &.exceed{ color:#f00; }
    }
    .cancel-notif{
      display: block;
      font-size: 13px;
      margin: 10px 0 0;
      text-align: center;
      cursor: pointer;
      color: #bbb;
      transition: all .5s ease;
      &:hover{ color:#333; }
    }
    .file-box{
      position: relative;

      input{
        padding: 5px 25px 5px 5px;
        margin:0;
        font-size: 14px;
      }
      i{
        position: absolute;
        z-index: 2;
        top: 50%;
        right: 5px;
        transform: translateY(-50%);
        color: #fd4a38;
        cursor: pointer;
      }
    }
  }

  .error{
    text-align: center;
    i{ color:#fd4a38; }
    p{ margin: 5px 0 20px; }
    code{
      border:2px solid #fd4a38;
      padding: 10px;
      width: 100%;
      display: block;
      font-size: 14px;
      background: #ffeeec;
      border-radius: 3px;
      margin-bottom: 30px;
    }
  }

  .success-box{
    text-align: center;
    i{ color: #26d97a; }
  }

  .loader{
    position: absolute;
    top:0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);

    div{
      position: absolute;
      top:50%;
      left: 0;
      height: 50px;
      width: 100%;
      transform: translateY(-50%);
      text-align: center;

      i{ color: #45e7f9; }
      span{
        color: #fff;
        font-size: 21px;
        font-weight: 600;
        margin-left: 5px;
        text-shadow: 1px 1px 1px rgba(0,0,0, .4);
      }
    }
  }
}

.emoji-box{
  position: absolute;
  top: 0;
  left: 100%;
  z-index: 2;
  width: 100%;
  height: 100%;
}

.slide-up-enter-active, .slide-up-leave-active { transition: all .6s ease; }
.slide-up-enter, .slide-up-leave-to {
  transform: translateY(30px);
  opacity: 0;
}

.slide-down-enter-active, .slide-down-leave-active { transition: all .6s ease; }
.slide-down-enter, .slide-down-leave-to {
  transform: translateY(-30px);
  opacity: 0;
}

.slide-left-enter-active, .slide-left-leave-active { transition: all .3s ease; }
.slide-left-enter, .slide-left-leave-to {
  transform: translateX(-30px);
  opacity: 0;
}

.pop-enter-active, .pop-leave-active { transition: all .3s ease; }
.pop-enter, .pop-leave-to {
  transform: scale(.8);
  opacity: 0;
}

@media only screen and (max-width: 430px) {

  .heading {
    font-size: 20px;
    display: flex;
    align-items: center;
  }
  
  .card-div {
    padding-top: 220px;
    padding-bottom: 70px;
  }
  .cards {
    width: 90%;
    margin: 0 auto;
    .card {
      border: 1px solid #ccc;
      margin-bottom: 15px;
      padding: 8px;
      padding-bottom: 3px;
      border-bottom: 5px solid #aaa9;
      border-radius: 10px;

      > div {
        margin-bottom: 3px;
      }

      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
          .time {
            font-size: 12px;
            color: #777;
            word-spacing: 5px;
          }

          .link {
            display: flex;
            align-items: center;
            gap: 10px;
          }
      }

      .credit-card {
        font-weight: 900;
      }

      .title {
        display: flex;
        align-items: center;

        input {
          margin-right: 5px;
        }

        &.view {
          justify-content: space-between;
          padding-top: 7px;
          padding-bottom: 5px;
          border-top: 1px solid #eee;
        }

        .refer {
          display: flex;
        }
      }


      .label {
        font-size: 12px;
        text-transform: uppercase;
        color: #bbb;
        font-weight: 600;
        margin-right: 5px;
      }

      .value {
        margin-right: 10px;
        font-size: 13px;
        font-weight: 900;
        i {
          color: #bbb;
        }
        a {
          text-decoration: none;
          text-transform: uppercase;
        }
      }
    }
  }
  .small-3 {
    width: 50%;
  }
  .fix-footer {
    .row {
      display: flex;
    }
    .per-page {
      width: auto;
      select {
        width: 55px;
      }
      span:nth-child(3) {
        display: none;
      }
    }
    .page-data {
      display: none;
    }
    .pagination {
      display: flex;
      align-items: center;

      select {
        width: 55px;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Consumer/List.vue